<template>
<v-card v-if="isGroupMember()" min-height="565" class="mx-auto">
  <v-app-bar color="primary" dark rounded flat>
    <v-layout justify-center>
      <span class="align-start font-weight-bold">Group Chat</span>
    <!-- <v-app-bar-title class="align-start font-weight-bold">Group Chat</v-app-bar-title> -->
    </v-layout>
  </v-app-bar>
  <v-container class="overflow-y-auto" id="scroll-target" style="max-height: 367px">
    <v-col cols="12"
     v-for="(item, i) in sortArrays(groupChatDatas)"
      :key="i"
      rounded
      outlined>
    
      <v-card color="#F5F5F5">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              {{item.message}}
            </v-card-text>
          </div>
          <v-card-actions>
            <v-list-item class="grow">
              <v-col cols="">
              <v-list-item-avatar>
                <v-img
                class=""
                :src="item.userPhotoURL"
                ></v-img>
              </v-list-item-avatar>
              </v-col>
              <v-col cols="4">
              <v-list-item-content class="font-weight-bold">
              {{item.userName}}
              </v-list-item-content>
              </v-col>
              <v-col cols="7">
              <v-list-item-content class="font-weight-bold">{{ chatAt(item.postingDate) }}</v-list-item-content>
              </v-col>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-container>
  <template>
    
    <v-form ref="chat_form" @submit.prevent>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="message"
              :append-icon="'mdi-send'"
              filled
              clear-icon="mdi-close-circle"
              clearable
              label="Message"
              type="text"
              :counter="30"
              @click:append="send"
              :rules="[rules.required, rules.max30]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </template>
</v-card>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
import _ from 'lodash'
import moment from "moment";
export default {
  computed: {
    chatAt(){
      return function(postingDate){
        return moment.unix(postingDate.seconds).format("MM月DD日 hh時mm分");
      }
    },
    ...mapGetters(['groupChatDatas',"loginUserId",'myGroupMembers'])
  },
  data: () => ({
    items: [
      {
        color: '#000080',
        src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
        title: 'Supermodel',
        user: '土屋',
        content: 'こんにちは。さっき腕立てやったよ。'
      },
    ],
    message: '',
    rules: {
      required: v => !!v || '空文字の投稿はできません', 
      max30: v => (v || '').length <= 30 || '最大30文字',
    }
  }),
  methods:{
    isGroupMember(){
        const loginUserId = this.loginUserId
        return this.myGroupMembers.some(member => member.userId === loginUserId)
      },
    sortArrays(arrays){
      return _.orderBy(arrays,(groupChatData => groupChatData.postingDate),'asc')
    },
    send(){
      if(!this.message) return
      const groupChatData = {
        message: this.message,
        userPhotoURL: this.$store.getters.loginUserPhotoURL,
        userName: this.$store.getters.loginUserName,
        userId: this.$store.getters.loginUserId,
        //postingDate: moment().format("MM月DD日hh時mm分ss秒")
        //momentからタイムスタンプに変更
        postingDate: new Date()
      }
      this.sendGroupChat(groupChatData);
      this.message = "";
      this.$refs.chat_form.reset();
    },
    ...mapActions(['sendGroupChat',])
  }
}
</script>
